import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchMatches } from '../api/services/matchfetchService';
import { createMatch, updateMatch, deleteMatch } from '../api/services/matchService';
import { queryKeys } from '../api/queryKeys';

// GET Matches
export function useMatches() {
  return useQuery({
    queryKey: queryKeys.matches.lists(),
    queryFn: fetchMatches,
    staleTime: 1000 * 60, // 1 Minute
  });
}

// CREATE Match
export function useCreateMatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMatch,
    onSuccess: () => {
      // Invalidate matches cache, so they get refetched
      queryClient.invalidateQueries({ queryKey: queryKeys.matches.all });
    },
  });
}

// UPDATE Match
export function useUpdateMatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ matchId, matchData }) => updateMatch(matchId, matchData),
    onSuccess: () => {
      // Invalidate matches cache, so they get refetched
      queryClient.invalidateQueries({ queryKey: queryKeys.matches.all });
    },
  });
}

// DELETE Match
export function useDeleteMatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteMatch,
    onMutate: async (matchId) => {
      // Optimistic Delete: Sofort aus UI entfernen
      await queryClient.cancelQueries({ queryKey: queryKeys.matches.all });
      const previousMatches = queryClient.getQueryData(queryKeys.matches.lists());

      // Optimistisch entfernen
      queryClient.setQueryData(queryKeys.matches.lists(), (old) =>
        old?.filter(match => match.id !== matchId)
      );

      return { previousMatches };
    },
    onError: (err, matchId, context) => {
      // Bei Fehler: Rollback
      queryClient.setQueryData(queryKeys.matches.lists(), context.previousMatches);
    },
    onSettled: () => {
      // Am Ende: Immer refetch
      queryClient.invalidateQueries({ queryKey: queryKeys.matches.all });
    },
  });
}
